import { render, staticRenderFns } from "./AppointmentEdit.vue?vue&type=template&id=110cf736&scoped=true&"
import script from "./AppointmentEdit.vue?vue&type=script&lang=js&"
export * from "./AppointmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110cf736",
  null
  
)

export default component.exports